import { Button, ButtonProps, ExternalStyles, Portal } from 'bold-ui'
import { usePopperButton } from 'hooks/usePopperButton'
import { PopperProps } from 'react-popper'

export interface PopperButtonProps extends ButtonProps {
  placement?: PopperProps<any>['placement']
  positioningStrategy?: PopperProps<any>['strategy']
  renderPopper: (controls: PopperControls) => React.ReactNode
  zIndex?: number
  onClose?(): void
  styleCallback?(isOpen: boolean): ExternalStyles
  container?: Element
  onOpen?(): void
  focusOnOpen?: boolean
  referenceElement?: Element
  closeOnBackdropClick?: boolean
  dataTestId?: string
}

export interface PopperControls {
  open(): void
  close(): void
  toggle(): void
}

export function PopperButton(props: PopperButtonProps) {
  const {
    placement,
    positioningStrategy,
    renderPopper,
    zIndex,
    onClose,
    onOpen,
    style,
    styleCallback,
    container,
    closeOnBackdropClick,
    focusOnOpen,
    referenceElement,
    dataTestId,
    ...buttonProps
  } = props

  const { rootRef, popperContainerRef, buttonRef, open, close, toggle, isOpen, popperContainerStyle } = usePopperButton(
    {
      referenceElement,
      placement,
      strategy: positioningStrategy,
      closeOnBackdropClick,
      focusOnOpen,
      zIndex,
      onClose,
      onOpen,
    }
  )

  return (
    <>
      <Button
        data-testid={dataTestId}
        innerRef={buttonRef}
        onClick={toggle}
        {...buttonProps}
        style={styleCallback ? styleCallback(isOpen) : style}
      />

      <Portal container={container}>
        <div ref={rootRef}>
          {isOpen && (
            <div
              ref={popperContainerRef}
              className={popperContainerStyle}
              data-placement={placement}
              data-visible={isOpen}
            >
              {renderPopper({ open, close, toggle })}
            </div>
          )}
        </div>
      </Portal>
    </>
  )
}
